import request from '@/plugin/axios'

export function page(query) {
    return request({
        url: '/api/case/czMessage/page',
        method: 'get',
        params: query
    })
}

export function addObj(obj) {
    return request({
        url: '/api/case/czMessage',
        method: 'post',
        data: obj
    })
}

export function getObj(id) {
    return request({
        url: '/api/case/czMessage/' + id,
        method: 'get'
    })
}

export function delObj(id) {
    return request({
        url: '/api/case/czMessage/' + id,
        method: 'delete'
    })
}

export function putObj(id, obj) {
    return request({
        url: '/api/case/czMessage/' + id,
        method: 'put',
        data: obj
    })
}
export function  handleReSend(id){
    return request({
        url: '/api/case/czMessage/reSendEmail/'+id,
        method: 'post',
      
    })

}
export function  sortEmail(status,listQuery){
    return request({
        url: '/api/case/czMessage/sort/'+status,
        method: 'post',
        data:listQuery
      
    })

}
export function cancelSend(id,title){
    return request({
        url: '/api/case/czMessage/turnOffPop',
        method: 'post',
        params:{
            taskId:id,
            title:title
        }
    })

}
export function getEmailNotify(){
    return request({
        url: '/api/case/czMessage/popUps',
        method: 'get',
      
    })
}